export default __webpack_public_path__ + "static/media/ruybon home img-cropped.159f2013.png";